module.exports = __webpack_public_path__ + "static/media/PaketE.02ae7d3a.jpeg";